import { ChangeDetectionStrategy, Component, inject, linkedSignal, signal } from '@angular/core';
import { FormField, disabled, form, required } from '@angular/forms/signals';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';

import { finalize } from 'rxjs';

import { Client } from '../schemas';
import { ClientService, Messenger } from '../service';

interface ClientFormData {
  client?: Client;
  title?: string;
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,

  imports: [
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatProgressBarModule,
    FormField,
  ],
  templateUrl: 'client-form.html',
  styles: [],
})
export class ClientForm {
  data = (inject(MAT_DIALOG_DATA) as ClientFormData) || {};

  hostDialog = inject(MatDialogRef);

  clientService = inject(ClientService);
  messenger = inject(Messenger);
  pending = signal(false);

  model = linkedSignal(
    () =>
      ({
        ClientCode: '',
        ClientName: '',
        XeroId: '',
        InsightlyId: '',
        AwsId: '',
        Commissionable: false,
        Notes: '',

        ...this.data.client,
      }) as Client,
  );
  form = form(this.model, (schema) => {
    required(schema.ClientCode);
    disabled(schema.ClientCode, () => !!this.data.client);
    required(schema.ClientName);
  });

  save() {
    const data = this.form().value();
    this.pending.set(true);
    this.clientService
      .save(data, !!this.data.client)
      .pipe(finalize(() => this.pending.set(false)))
      .subscribe({
        next: (client) => {
          this.hostDialog.close(client);
        },
        error: this.messenger.handleHttpError,
      });
  }
}
